import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Modal,
  Rating,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Postrequestcall } from "../../request/Postrequest";
import { SAVE_PRODUCT_RATINGS } from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";

const ReviewInputModal = ({ open, onClose, mainId, onSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    TEXT_WRITE_A_REVIEW = English?.ReviewInputModal?.TEXT_WRITE_A_REVIEW,
    TEXT_WRITE_ABOUT_PRODUCT = English?.ReviewInputModal?.TEXT_WRITE_ABOUT_PRODUCT,
    BUTTON_POST = English?.ReviewInputModal?.BUTTON_POST
  } = multiLanguageData?.ReviewInputModal || {};

  const onPostClick = async () => {
    try {
      setSubmitLoading(true);
      const obj = {
        ReturnRecordId: false,
        ReturnRecordError: true,
        UserId: currentUserId,
        SaveList: [
          {
            Id: 0,
            ProductId: mainId,
            Rating: rating,
            Comments: comment,
            ModifiedBy: currentUserId
          }
        ]
      };
      await Postrequestcall(SAVE_PRODUCT_RATINGS, obj, loginData?.accessToken);
      onSave();
    } catch (error) {
      setSubmitLoading(false);
      console.log("onPostClick-> Error When Saving Product Ratings: ", error);
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_WRITE_A_REVIEW}</Typography>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Stack spacing={1.5}>
          <ListItem sx={{ pb: 0 }}>
            <ListItemAvatar>
              <Avatar alt="contact-PictureUrl" src={loginData?.pictureUrl} />
            </ListItemAvatar>
            <ListItemText
              primary={
                <Stack direction={"row"} spacing={0.5}>
                  <Typography variant="body1" maxWidth={"150px"} noWrap>
                    {loginData?.userInformation?.FirstName}
                  </Typography>
                  <Typography variant="body1" maxWidth={"150px"} noWrap>
                    {loginData?.userInformation?.LastName}
                  </Typography>
                </Stack>
              }
              secondary={
                <Typography variant="body2" sx={{ color: "text.secondary" }} maxWidth={"200px"} noWrap>
                  {loginData?.userInformation?.TradeName !== ""
                    ? loginData?.userInformation?.TradeName
                    : "No Trade"}
                </Typography>
              }
            />
          </ListItem>
          <Stack sx={{ pb: 1, pl: 1 }}>
            <Rating
              name="simple-controlled"
              value={rating}
              onChange={(event, newValue) => setRating(newValue)}
            />
          </Stack>
          <TextField
            variant="outlined"
            slotProps={{
              input: {
                rows: 5,
                multiline: true,
                inputComponent: "textarea"
              }
            }}
            minRows={5}
            fullWidth
            value={comment}
            onChange={(event) => {
              let inputValue = event.target.value;
              inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
              setComment(inputValue);
            }}
            placeholder={TEXT_WRITE_ABOUT_PRODUCT}
          />
          <Button
            variant="contained"
            loading={submitLoading}
            onClick={onPostClick}
            disabled={comment?.trim() === "" && rating === 0}>
            {BUTTON_POST}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ReviewInputModal;
